"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HealthIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HealthIcon, _PureComponent);

  function HealthIcon() {
    _classCallCheck(this, HealthIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HealthIcon).apply(this, arguments));
  }

  _createClass(HealthIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "-1.114 -1.555 37.858 33.642",
        enableBackground: "new -1.114 -1.555 37.858 33.642",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("g", {
        id: "Group_2308",
        transform: "translate(0 175.004)"
      }, _react2.default.createElement("g", null, _react2.default.createElement("g", {
        id: "Group_2324",
        transform: "translate(0 -175.004)"
      }, _react2.default.createElement("g", {
        id: "Group_2322",
        transform: "translate(0 0)"
      }, _react2.default.createElement("path", {
        id: "Path_1393",
        d: "M32.271,16.305l-1.9,1.965v-3.28c-0.002-1.76-1.428-3.186-3.188-3.188h-1.199c-1.76,0.002-3.186,1.428-3.188,3.188v3.428h-3.428c-1.76,0.001-3.186,1.428-3.187,3.187v1.201c0.001,1.759,1.427,3.185,3.187,3.187h3.428v0.1L19.05,29.96c-0.817,0.856-2.175,0.887-3.031,0.069c-0.023-0.023-0.046-0.046-0.068-0.069L2.724,16.302C-1.023,12.386-0.886,6.173,3.03,2.426C3.15,2.312,3.273,2.2,3.399,2.091c3.832-3.103,9.415-2.695,12.755,0.931l1.347,1.388l1.347-1.388c3.342-3.625,8.924-4.033,12.756-0.931c4.1,3.541,4.552,9.734,1.011,13.834c-0.11,0.128-0.226,0.255-0.343,0.377"
      })), _react2.default.createElement("g", {
        id: "Group_2323",
        transform: "translate(18.162 13.787)"
      }, _react2.default.createElement("path", {
        id: "Path_1394",
        d: "M15.635,6.615h-5.412V1.2c0-0.663-0.537-1.2-1.199-1.2H7.822C7.16,0,6.623,0.537,6.623,1.2v5.412H1.211c-0.662,0-1.2,0.537-1.2,1.201v1.199c0,0.663,0.538,1.2,1.2,1.2h5.412v5.412c0,0.663,0.537,1.2,1.199,1.2h1.201c0.662,0,1.199-0.537,1.199-1.2v-5.412h5.412c0.663,0,1.2-0.537,1.2-1.2V7.813c0-0.664-0.537-1.201-1.2-1.201"
      }))))));
    }
  }]);

  return HealthIcon;
}(_react.PureComponent);

exports.default = HealthIcon;